import React from 'react';
import { Flex, Text, useTheme } from '@aws-amplify/ui-react';

function Footer() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={tokens.space.medium}>
      <Text>
        &copy;
        {' '}
        {(new Date()).getFullYear()}
        {' '}
        ARK Design, LTD. All rights reserved.
      </Text>
    </Flex>
  );
}

export default Footer;
